import React, { useEffect, useState, useRef, useCallback, useLayoutEffect } from 'react';
import { useDrag, useDragLayer } from 'react-dnd';
import { getEmptyImage } from "react-dnd-html5-backend";
import styled from 'styled-components';
import Animation from './Animation'

// Original Draggable //
const DraggableContainer = styled.div`
    width:100%;
    flex-grow: 4;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 5px;
`

const Container = styled.div`
    box-sizing: border-box;
    width: 100%;
`

export const Draggable = (props) => {
    const {
        index,
        id,
        onStartDragHandler,
        onEndDragHandler,
        disableDrag
    } = props;
    const ref = useRef();
    const [width, setWidth] = useState(0)
    const [height, setHeight] = useState(0)
    const [drop, setDrop] = useState(false)
    const [{isDragging},drag, preview] = useDrag({
        item: {
            type: props.type, 
            props, 
            width: width ? width 
                        : ref.current ? ref.current.offsetWidth 
                        : null, 
            height: height ? height 
                        : ref.current ? ref.current.offsetHeight 
                        : null}, // Width for CustomDragLayer
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        }),
        begin(monitor) {
            onStartDragHandler && onStartDragHandler(index, id, props);
            setDrop(false)
        },
        end(item, monitor) {
            onEndDragHandler && onEndDragHandler();
            setDrop(monitor.didDrop())
        },
        canDrag(monitor) {
            return disableDrag ? false : true
        }
    })

    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true });
    }, []);

    // Ensure ref is mounted to get width for CustomDragLayer
    useLayoutEffect(() => {
        setWidth(ref.current.offsetWidth)
        setHeight(ref.current.offsetHeight)
    })
    return (
        <DraggableContainer key={id} isDragging={isDragging} ref={drag}>
            <Container isDragging={isDragging} ref={ref}>
                {props.children}
            </Container>
        </DraggableContainer>
    ) 
    
}

export default Draggable
